import XLSX from 'xlsx'
import download from 'downloadjs'

import { onlyNumber } from '../normalize'

export const getStatusName = status => {
  switch (status) {
    case 1:
      return 'Em Análise'
    case 2:
      return 'Em Negociação'
    case 3:
      return 'Em Finalização'
    case 999:
      return 'Arquivado'
    default:
  }
}

export const formatDate = (date, includeTime = true) => {
  if (!date) {
    return ''
  }
  date = new Date(date)

  let day = date.getDate()
  let month = date.getMonth() + 1;
  let year = date.getFullYear()
  let hours = date.getHours()
  let minutes = date.getMinutes()

  if (day.toString().length == 1)
    day = '0' + day

  if (month.toString().length == 1)
    month = '0' + month

  if (hours.toString().length == 1)
    hours = '0' + hours

  if (minutes.toString().length == 1)
    minutes = '0' + minutes

  return `${day}/${month}/${year}` + (includeTime ? ` ${hours}:${minutes}` : '')
}

export const formatCaptureDate = (date) => {
  if (!date) {
    return ''
  }

  date = new Date(date)
  date.setHours(date.getHours() + 3)
  let day = date.getDate()
  let month = date.getMonth() + 1;
  let year = date.getFullYear()
  let hours = date.getHours()
  let minutes = date.getMinutes()

  if (day.toString().length == 1)
    day = '0' + day

  if (month.toString().length == 1)
    month = '0' + month

  if (hours.toString().length == 1)
    hours = '0' + hours

  if (minutes.toString().length == 1)
    minutes = '0' + minutes

  return `${day}/${month}/${year}`
}

export const formatReal = (number, prefix = true) => {
  if (typeof (number) === 'number') {
    return (prefix ? "R$ " : '') + number.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+,)/g, "$1.");
  } else {
    return number
  }
}

export const secureData = string => {
  let securedData = ''
  let afterAt = false
  let afterAtAndDot = false

  for (var i = 0, len = string.length; i < len; i++) {
    if (i <= 2 || afterAtAndDot) {
      securedData += string[i]
    } else if (string[i] === '@') {
      securedData += string[i]
      afterAt = true
    } else if (afterAt && string[i] === '.') {
      securedData += string[i]
      afterAtAndDot = true
    } else {
      securedData += '*'
    }
  }
  return securedData
}

export const getLocalStorage = () => {
  const lawFirm = localStorage.getItem('lawFirm')
  const lawFirmId = localStorage.getItem('lawFirmId')
  const group = localStorage.getItem('group')
  const groupId = localStorage.getItem('groupId')

  return {
    admin: localStorage.getItem('admin') === 'false' ? false : true,
    approved: localStorage.getItem('approved') === 'false' ? false : true,
    companies: JSON.parse(localStorage.getItem('companies')),
    email: localStorage.getItem('email'),
    group: group === 'null' ? null : group,
    groupId: groupId === 'null' ? null : groupId,
    id: localStorage.getItem('id'),
    image: localStorage.getItem('image'),
    lawFirm: lawFirm === 'null' ? null : lawFirm,
    lawFirmId: lawFirmId === 'null' ? null : lawFirmId,
    manager: localStorage.getItem('manager') === 'false' ? false : true,
    name: localStorage.getItem('name'),
    permissionLevel: Number(localStorage.getItem('permissionLevel')),
    phone: localStorage.getItem('phone'),
    role: localStorage.getItem('role'),
    surname: localStorage.getItem('surname'),
    temporary: localStorage.getItem('temporary') === 'false' ? false : true,
    token: localStorage.getItem('token'),
    capture: localStorage.getItem('capture') === 'false' ? false : true,
    updatedPassword: localStorage.getItem('updatedPassword'),
    groupExpiredPassword: localStorage.getItem('groupExpiredPassword') === 'false' ? false : true
  }
}

export const exportAsXls = (data, fileName, sheetName) => {
  var ws = XLSX.utils.json_to_sheet(data);

  // Add to workbook
  var wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);

  // Write workbook
  var str = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

  download(str, fileName + '.xlsx', 'application/vnd.ms-excel');
}

export const accentFolding = (value) => {
  return value
    .replace(/[aáâäàã]/g, '[aáâäàã]')
    .replace(/[eéêëè]/g, '[eéêëè]')
    .replace(/[iíîïì]/g, '[iíîïì]')
    .replace(/[oóôöòõ]/g, '[oóôöòõ]')
    .replace(/[uúûüù]/g, '[uúûüù]')
}

export const getLawsuitSegment = (lawsuitNumber) => {
  const j = lawsuitNumber.substring(16, 17)
  let lawsuitSegment = 'Justiça Comum'
  let clientLabel = 'Autor'
  let companyLabel = 'Ré'

  switch (Number(j)) {
    case 4:
      lawsuitSegment = 'Justiça Federal'
      break;
    case 5:
      lawsuitSegment = 'Justiça do Trabalho'
      clientLabel = 'Reclamante'
      companyLabel = 'Reclamada'
      break;
      break;
    default:
  }

  return { segment: lawsuitSegment, clientLabel, companyLabel }
}

export const getlinkToTJ = (lawsuitNumber, lawsuitUf) => {
  let link = ''

  if (lawsuitNumber && lawsuitNumber.length == 25 && lawsuitUf) {
    const lawsuitNumberOnlyNumber = onlyNumber(lawsuitNumber)
    const links = [
      {},
      {},
      {},
      {},
      {},
      {
        'AC': `http://pje.trt14.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'AL': `http://pje.trt19.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'AP': `http://pje.trt8.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'AM': `https://pje.trt11.jus.br/consultaprocessual/detalhe-processo/${lawsuitNumber}`,
        'BA': `http://pje.trt5.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'CE': `http://pje.trt7.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'DF': `http://pje.trt10.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'ES': `http://pje.trt17.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'GO': `http://pje.trt18.jus.br/consultaprocessual/detalhe-processo/${lawsuitNumber}`,
        'MA': `http://pje.trt16.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'MT': `http://pje.trt23.jus.br/consultaprocessual/detalhe-processo/${lawsuitNumber}`,
        'MS': `http://pje.trt24.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'MG': `http://pje.trt3.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'PA': `http://pje.trt8.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'PB': `http://consultaprocessual.trt13.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'PR': `http://pje.trt9.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'PE': `http://pje.trt6.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'PI': `https://pje.trt22.jus.br/consultaprocessual/detalhe-processo/${lawsuitNumber}`,
        'RJ': `http://pje.trt1.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'RN': `http://pje.trt21.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'RS': `http://pje.trt4.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'RO': `http://pje.trt14.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'RR': `https://pje.trt11.jus.br/consultaprocessual/detalhe-processo/${lawsuitNumber}`,
        'SC': `http://pje.trt12.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'SP': `http://consulta.pje.trtsp.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'SE': `http://pje.trt20.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
        'TO': `http://pje.trt10.jus.br/consultaprocessual/pages/consultas/ListaProcessos.seam?numero_unic=${lawsuitNumber}`,
      },
      {},
      {},
      {
        'AC': `http://esaj.tjac.jus.br/cpopg/search.do?conversationId=&dadosConsulta.localPesquisa.cdLocal=-1&cbPesquisa=NUMPROC&dadosConsulta.tipoNuProcesso=UNIFICADO&numeroDigitoAnoUnificado=${lawsuitNumber.substring(0, 15)}&foroNumeroUnificado=${lawsuitNumber.substring(21, 25)}&dadosConsulta.valorConsultaNuUnificado=${lawsuitNumber}&dadosConsulta.valorConsulta=&uuidCaptcha=`,
        'AL': `http://www2.tjal.jus.br/cpopg/search.do?conversationId=&dadosConsulta.localPesquisa.cdLocal=-1&cbPesquisa=NUMPROC&dadosConsulta.tipoNuProcesso=UNIFICADO&numeroDigitoAnoUnificado=${lawsuitNumber.substring(0, 15)}&foroNumeroUnificado=${lawsuitNumber.substring(21, 25)}&dadosConsulta.valorConsultaNuUnificado=${lawsuitNumber}&dadosConsulta.valorConsulta=&uuidCaptcha=`,
        'AP': `http://tucujuris.tjap.jus.br/api/publico/buscar-autos-consulta-publica?id=&numero_unico=${lawsuitNumber}&nome_parte=&documento_parte=&nome_advogado=&oab_advogado=&numero_carta_precatoria=&situacao_processo=&captcha=`,
        'AM': `http://consultasaj.tjam.jus.br/cpopg/search.do?conversationId=&dadosConsulta.localPesquisa.cdLocal=-1&cbPesquisa=NUMPROC&dadosConsulta.tipoNuProcesso=UNIFICADO&numeroDigitoAnoUnificado=${lawsuitNumber.substring(0, 15)}&foroNumeroUnificado=${lawsuitNumber.substring(21, 25)}&dadosConsulta.valorConsultaNuUnificado=${lawsuitNumber}&dadosConsulta.valorConsulta=&uuidCaptcha=`,
        'BA': `http://esaj.tjba.jus.br/cpopg/search.do?conversationId=&dadosConsulta.localPesquisa.cdLocal=-1&cbPesquisa=NUMPROC&dadosConsulta.tipoNuProcesso=UNIFICADO&numeroDigitoAnoUnificado=${lawsuitNumber.substring(0, 15)}&foroNumeroUnificado=${lawsuitNumber.substring(21, 25)}&dadosConsulta.valorConsultaNuUnificado=${lawsuitNumber}&dadosConsulta.valorConsulta=&uuidCaptcha=`,
        'CE': `http://esaj.tjce.jus.br/cpopg/search.do?conversationId=&dadosConsulta.localPesquisa.cdLocal=-1&cbPesquisa=NUMPROC&dadosConsulta.tipoNuProcesso=UNIFICADO&numeroDigitoAnoUnificado=${lawsuitNumber.substring(0, 15)}&foroNumeroUnificado=${lawsuitNumber.substring(21, 25)}&dadosConsulta.valorConsultaNuUnificado=${lawsuitNumber}&dadosConsulta.valorConsulta=&uuidCaptcha=`,
        'DF': '',
        'ES': '',
        'GO': `http://pjd.tjgo.jus.br/BuscaProcessoPublica?numeroProcessoConsulta=${lawsuitNumberOnlyNumber}&PaginaAtual=2&Passo=6`,
        'MA': '',
        'MT': '',
        'MS': `https://esaj.tjms.jus.br/cpopg5/search.do?conversationId=&dadosConsulta.localPesquisa.cdLocal=1&cbPesquisa=NUMPROC&dadosConsulta.tipoNuProcesso=UNIFICADO&numeroDigitoAnoUnificado=${lawsuitNumber.substring(0, 15)}&foroNumeroUnificado=${lawsuitNumber.substring(21, 25)}&dadosConsulta.valorConsultaNuUnificado=${lawsuitNumber}&dadosConsulta.valorConsulta=&uuidCaptcha=`,
        'MG': `http://www4.tjmg.jus.br/juridico/sf/proc_resultado.jsp?comrCodigo=24&numero=1&listaProcessos=${lawsuitNumberOnlyNumber}&btn_pesquisar=Pesquisar`,
        'PA': '',
        'PB': '',
        'PR': '',
        'PE': '',
        'PI': '',
        'RJ': `http://www4.tjrj.jus.br/numeracaoUnica/faces/index.jsp?numProcesso=${lawsuitNumber}`,
        'RN': `http://esaj.tjrn.jus.br/cpopg/search.do?conversationId=&dadosConsulta.localPesquisa.cdLocal=-1&cbPesquisa=NUMPROC&dadosConsulta.tipoNuProcesso=UNIFICADO&numeroDigitoAnoUnificado=${lawsuitNumber.substring(0, 15)}&foroNumeroUnificado=${lawsuitNumber.substring(21, 25)}&dadosConsulta.valorConsultaNuUnificado=${lawsuitNumber}&dadosConsulta.valorConsulta=&uuidCaptcha=`,
        'RS': '',
        'RO': '',
        'RR': '',
        'SC': `http://esaj.tjsc.jus.br/cpopg/search.do?conversationId=&dadosConsulta.localPesquisa.cdLocal=-1&cbPesquisa=NUMPROC&dadosConsulta.tipoNuProcesso=UNIFICADO&numeroDigitoAnoUnificado=${lawsuitNumber.substring(0, 15)}&foroNumeroUnificado=${lawsuitNumber.substring(21, 25)}&dadosConsulta.valorConsultaNuUnificado=${lawsuitNumber}&dadosConsulta.valorConsulta=&uuidCaptcha=`,
        'SP': `http://esaj.tjsp.jus.br/cpopg/search.do?conversationId=&dadosConsulta.localPesquisa.cdLocal=-1&cbPesquisa=NUMPROC&dadosConsulta.tipoNuProcesso=UNIFICADO&numeroDigitoAnoUnificado=${lawsuitNumber.substring(0, 15)}&foroNumeroUnificado=${lawsuitNumber.substring(21, 25)}&dadosConsulta.valorConsultaNuUnificado=${lawsuitNumber}&dadosConsulta.valorConsulta=&uuidCaptcha=`,
        'SE': '',
        'TO': ''
      },
      {}
    ]

    link = links[Number(lawsuitNumber.substring(16, 17))][lawsuitUf.toUpperCase()]
  }

  return link
}

export const getGreeting = () => {
  let now = new Date()
  let hours = now.getHours()

  if (hours < 13) {
    return "Bom dia"
  }
  else if (hours < 18) {
    return "Boa tarde"
  }
  else {
    return "Boa noite"
  }
}